export default "__VITE_ASSET__C29uN2vI__"